import Phaser from 'phaser';
import SettingsHelper from './modules/SettingsHelper.js';

export default class BootScene extends Phaser.Scene {
    constructor() {
        super('BootScene');
    }

    init() {
        // 启动场景初始化

        // 设置游戏的基本配置
        this.game.registry.set('gameVersion', '1.0.0');
        this.game.registry.set('debugMode', false);

        // 初始化游戏状态
        this.initGameState();

        // 设置输入配置
        this.input.mouse.capture = true;

        // 设置游戏模式为像素风格，符合FC游戏特点
        this.game.config.pixelArt = true;
        this.game.config.antialias = false;
    }

    preload() {
        // 预加载场景已处理资源加载
    }

    create() {
        // 设置游戏画布的渲染模式 - 像素风格
        this.cameras.main.backgroundColor = Phaser.Display.Color.ValueToColor(0x000000);
        this.game.canvas.style.imageRendering = 'pixelated';

        // 创建FC风格启动画面效果
        this.createFCBootEffect();

        // 跳转到预加载场景
        this.time.delayedCall(300, () => {
            this.scene.start('PreloaderScene');
        }, [], this);
    }
    
    initGameState() {
        // BootScene是游戏中唯一的游戏状态初始化点

        window.gameState = {
            // 主角信息
            player: {
                tileX: 147,
                tileY: 410,
                name: '',
                element: '',
                hp: 0,
                maxHp: 0,
                cost: 0,
                maxCost: 0,
                attack: 0,
                defense: 0,
                speed: 0,
                level: 1,
                exp: 0,
                nextLevelExp: 100,
                money: 0,
                inVehicle: false,
                vehicle: {
                    // 战车基础属性
                    name: '',
                    element: '',
                    hp: 0,
                    maxHp: 0,
                    sp: 0,
                    maxSp: 0,
                    // 抗腐蚀图层系统（使用CP值）
                    cp: 0,
                    maxCp: 0,
                    corrosionLayer: 0,
                    maxCorrosionLayer: 0,
                    // 装备槽位
                    equipment: {
                        mainCannon: null,  // 主炮
                        subCannon: null,   // 副炮
                        se: null,          // S-E
                        ai: null,          // AI装置（必须）
                        engine: null,      // 发动机（必须）
                        chassis: null     // 底盘（必须）
                    },
                    // 弹药系统
                    ammo: {
                        cannon_ammo: 0,    // 主炮弹药
                        se_ammo: 0         // S-E弹药
                    }
                },
                battle: '主角1',
                skills: [],
                inventory: [],
                equipment: [
                ],
                class: '',
                initialScene: 'map_rado'  // 初始场景，可以自定义修改
            },

            // 队伍系统
            party: [
                {
                    id: 1,
                    name: '老四',
                    class: '战车驾驶员',
                    inParty: true
                }
            ],

            // 游戏设置（使用SettingsHelper加载）
            settings: SettingsHelper.getSettings()
        };


    }

    createFCBootEffect() {
        const centerX = this.cameras.main.centerX;
        const centerY = this.cameras.main.centerY;

        this.titleText = this.add.text(
            centerX,
            centerY,
            '老四出品',
            {
                fontSize: '16px',
                fill: '#ffffff',
                fontFamily: 'monospace',
                align: 'center',
                lineSpacing: 10
            }
        );
        this.titleText.setOrigin(0.5);

        this.tweens.add({
            targets: this.titleText,
            alpha: [1, 0.8, 1],
            duration: 800,
            repeat: -1,
            ease: 'Sine.easeInOut'
        });
    }

}